import React from 'react';
import { useTranslation } from 'react-i18next';

import { PopupMenu, TextButton, Column } from 'design-system-web';
import { Product } from 'lane-shared/domains/billingPayments/types';

import { useGetActionsForProducts } from './useGetActionsForProducts';
import { useGetProductsServicesColumns } from './useGetProductsServicesColumns';

export function useGetProductsServicesTableColumns(
  channelId: string | undefined,
  onDelete: (product: Product) => void,
  canManage?: boolean
): Column<Product>[] {
  const { t } = useTranslation();

  const columns = useGetProductsServicesColumns(channelId);

  const productActions = useGetActionsForProducts({ onDelete });

  const actionColumn: Column<Product> = {
    key: 'actions',
    header: t('abp.actions'),
    renderCell: (_cell: boolean, row: Product) => {
      return (
        <PopupMenu
          trigger={
            <TextButton iconName="angle-down" testId="productActionsButton">
              {t('abp.actions')}
            </TextButton>
          }
          items={productActions.map(({ label, onSelect, testId }) => ({
            label,
            onSelect: () => {
              onSelect(row);
            },
            isDisabled: false,
            testId,
          }))}
        />
      );
    },
    disableSorting: true,
  };

  if (canManage) columns.push(actionColumn);

  return columns;
}
